<script lang="ts">
  import { CheckCircle2, XCircle, Info, X } from 'lucide-svelte';
  import { toast } from '$lib/state/toast.svelte';

  const ICONS = { success: CheckCircle2, error: XCircle, info: Info };
  const ICON_COLOR: Record<string, string> = {
    success: 'text-toyama-lime',
    error: 'text-red-600',
    info: 'text-toyama-teal'
  };
</script>

<div
  class="pointer-events-none fixed inset-x-0 bottom-4 z-[100] flex flex-col items-center gap-2 px-4 sm:bottom-6 sm:items-end sm:pr-6"
  aria-live="polite"
  role="status"
>
  {#each toast.items as t (t.id)}
    {@const Icon = ICONS[t.kind]}
    <div class="tym-card pointer-events-auto flex w-full max-w-sm items-start gap-2.5 px-4 py-3 shadow-lg">
      <Icon class="mt-0.5 h-4 w-4 shrink-0 {ICON_COLOR[t.kind]}" />
      <span class="flex-1 text-[13px] text-navy">{t.text}</span>
      <button
        type="button"
        class="shrink-0 text-dark-gray hover:text-navy"
        onclick={() => toast.dismiss(t.id)}
        aria-label="Dismiss notification"
      >
        <X class="h-4 w-4" />
      </button>
    </div>
  {/each}
</div>
